import { render, staticRenderFns } from "./TheFooterUser.vue?vue&type=template&id=530fb2f2&scoped=true"
import script from "./TheFooterUser.vue?vue&type=script&lang=js"
export * from "./TheFooterUser.vue?vue&type=script&lang=js"
import style0 from "./TheFooterUser.vue?vue&type=style&index=0&id=530fb2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530fb2f2",
  null
  
)

export default component.exports